'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.wrapWithDispatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _connect = require('./connect');

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var wrapWithDispatch = exports.wrapWithDispatch = function wrapWithDispatch(createFunctions) {
	if (typeof createFunctions !== 'function') {
		throw new TypeError('Could not wrap with dispatch since it is not a function');
	}

	return function (dispatch, props) {
		var functions = createFunctions(props);
		return Object.keys(functions).reduce(function (accumulator, key) {
			if (typeof functions[key] !== 'function') {
				throw new TypeError('Could not wrap ' + key + ' with dispatch since it is not a function');
			}

			return _extends({}, accumulator, _defineProperty({}, key, function () {
				return dispatch(functions[key].apply(functions, arguments));
			}));
		}, {});
	};
};

exports.default = function (mapStateToProps, mapDispatchToProps, mergeProps, options) {
	return function (component) {
		try {
			return (0, _connect2.default)(mapStateToProps, mapDispatchToProps && wrapWithDispatch(mapDispatchToProps), mergeProps, options)(component);
		} catch (err) {
			var name = component.name || 'anonymous component';
			console.warn('Component has no name', component);
			throw new Error('Error while connecting ' + name + ': ' + err);
		}
	};
};